/**
 * POST /customers/collections/{id}/toggle-follow yalnızca güncel `is_followed`
 * durumunu döndürüyor — takipçi sayısını yeniden hesaplamıyor (bkz.
 * ToggleFollowData). Sayı client tarafında ±1 uygulanarak güncellenir.
 *
 * `followers_count_text` API'den "12 Takipçi" gibi hazır formatlanmış
 * geliyor; baştaki sayı kısmı (tr-TR binlik ayraçlı, ör. "1.234") yeni
 * değerle değiştirilir, geri kalan etiket olduğu gibi korunur. Metin
 * beklenmedik bir formatta gelirse (rakamla başlamıyorsa) sayı yine de
 * güncellenir, yalnızca metin değişmeden kalır.
 */
export const bumpFollowersCount = (
  count: number,
  text: string,
  delta: 1 | -1,
): { count: number; text: string } => {
  const nextCount = Math.max(0, count + delta);
  const match = text.match(/^[\d.,]+/);
  const nextText = match
    ? text.replace(match[0], nextCount.toLocaleString("tr-TR"))
    : text;
  return { count: nextCount, text: nextText };
};
